import { create } from 'zustand';
var gnb = create(function (set) { return ({
    openCurrentMenuProfiles: function (pathName) {
        switch (pathName) {
            // case GNB_MENU.SEARCH.pathName:
            //   return JSON.parse(localStorage.getItem(CACHE_KEY.OPEN_SEARCH_PROFILES) as string) || [];
            default:
                // 선언되지 않은 메뉴는 new 표기 제외
                return ['excluded'];
        }
    },
    setOpenMenuProfile: function (pathName, profileNo) {
        set(function (state) {
            if (pathName && profileNo) {
                var cacheKey = '';
                var currentMenuProfiles = state.openCurrentMenuProfiles(pathName);
                currentMenuProfiles.push(profileNo);
                // switch (pathName) {
                //   case GNB_MENU.SEARCH.pathName:
                //     cacheKey = CACHE_KEY.OPEN_SEARCH_PROFILES;
                //     break;
                //   default:
                //     break;
                // }
                if (cacheKey) {
                    localStorage.setItem(cacheKey, JSON.stringify(currentMenuProfiles));
                }
            }
            return state;
        });
    },
}); });
export var useGnbStore = gnb;
